<template>
  <card-dialog
    v-model="modalVisible"
    max-width="600px"
    :title="$t('card_dialog.exercise_history.title')"
  >
    <template v-slot:title>
      <v-card-title
        class="blue-grey lighten-5 px-6 py-4"
      >
        <div>
          <div>
            {{ $t("card_dialog.previous_realizations.title") }}
          </div>
          <div class="text-body-1 mt-1">
            {{ player.first_name }} {{ player.last_name }} &middot; {{ trainingExercise.name }}
          </div>
        </div>
      </v-card-title>
    </template>

    <v-card-text
      class="pa-6"
    >
      <div
        v-if="stats.loading"
        class="text-center py-8 grey--text"
      >
        <div>
          <v-progress-circular
            :size="40"
            indeterminate
          />
        </div>
        <div class="mt-4">
          {{ $t('loading.message') }}...
        </div>
      </div>
      <div
        v-else-if="stats.data.length === 0"
        class="text-center py-8 grey--text"
      >
        <div>
          {{ $t("card_dialog.previous_realizations.label") }}
        </div>
      </div>
      <div v-else>
        <player-exercise-history-dialog-row
          v-for="(exercise, index) in stats.data"
          :key="index"
          :training-exercise-group-id="groupId"
          :data="exercise"
          class="mb-2 grey lighten-4"
        />
      </div>
    </v-card-text>
  </card-dialog>
</template>

<script>
import CardDialog from '@/components/helpers/CardDialog'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import { PlayerApiService } from '@/data/services'
import PlayerExerciseHistoryDialogRow from '@/components/training-builder/PlayerExerciseHistoryDialogRow.vue'

export default {
  name: 'PlayerExerciseHistoryDialog',
  components: { PlayerExerciseHistoryDialogRow, CardDialog },
  mixins: [deleteConfirmationMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    trainingExercise: {
      type: Object,
      required: true
    },
    groupId: {
      type: String,
      required: true
    },
    player: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      stats: {
        loading: false,
        data: []
      }
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  watch: {
    visible: function (value) {
      if (!value) return

      this.fetchExerciseStats()
    }
  },
  methods: {
    async fetchExerciseStats() {
      this.stats.loading = true

      try {
        const result = await PlayerApiService.getTrainingExerciseStats(this.player.id, {
          group_id: this.groupId,
          training_exercise_id: this.trainingExercise.exercise_id,
          page: 1,
          per_page: 15
        })

        this.stats.data = result.data
      } catch (e) {
        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.loading_training_history.error'),
          color: 'error'
        })

        throw e
      } finally {
        this.stats.loading = false
      }
    }

  }
}
</script>
